import {Aviso} from "./Aviso";

export class ColecaoAviso {

  list: Aviso[];

}
